import * as React from 'react';
import styled from 'styled-components';
import { Dialog } from '@progress/kendo-react-dialogs';
import { stopPropagationAndSetState } from '../../../lib/utils';
import Buttons from '../Buttons';
import { grey26 } from '../../cssConstants';

const GenericDialog = (props: Props) => {
	return (
		<DialogWrapper className="genericDialog" onClick={stopPropagationAndSetState(props.onClose)}>
			<Dialog onClose={props.onClose} title={props.title} height={props.height} width={props.width}>
				<Content>
					{props.children}
					<Buttons>{props.buttons}</Buttons>
				</Content>
			</Dialog>
		</DialogWrapper>
	);
};

interface Props {
	children: JSX.Element | JSX.Element[];
	buttons: JSX.Element | JSX.Element[];
	onClose: () => void;
	title?: string;
	height?: number;
	width?: number;
}

GenericDialog.defaultProps = {
	title: null,
	height: undefined,
	width: undefined
};

const DialogWrapper = styled.div`
	.k-dialog {
		border-radius: 3px;
	}

	.k-window-content {
		padding: 16px;
	}
`;

const Content = styled.div`
	h1 {
		margin-top: 0;
		font-size: 24px;
		font-weight: bold;
		color: rgba(38, 38, 38, 0.65);
	}

	p {
		font-weight: 400;
		font-size: 16px;
		line-height: 1.33em;
		color: ${grey26};
		margin: 0;
	}
	padding-bottom: 16px !important;
`;

export default GenericDialog;
